export const FASE_DOT = { "Desarrollo · Horma": "#a855f7", "Diseño": "#8b5cf6", "Prototipo": "#3b82f6", "Muestra": "#f59e0b", "Cierre": "#0ea5e9", "Alta de Producto": "#14b8a6" };
